import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const accordionDefinition: ComponentDefinition = {
  id: 'accordionDefinition',
  name: 'Accoridion container',
  category: 'Custom',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/list-collapse.svg',
  children: true,
  variables: {
    allowMultiple: {
      type: 'Boolean',
      displayName: 'Allow Multiple',
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    defaultOpen: {
      type: 'Text',
      displayName: 'Default open',
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
  },
} as const;
